module.exports = __webpack_public_path__ + "static/media/profile-driver.2e770ed9.svg";